'use strict';
angular.module('bringgApp').service('TasksProgressDrawer', function (TasksProgress) {
	var _this = this;
	_this.draw = draw;

	var _colorsByStatus = {};
	var DEFAULT_COLOR = '#BDBDBD';

	function ctor() {
		_colorsByStatus[TasksProgress.TASK_PROGRESS_STATUS.not_done_yet] = '#BDBDBD';
		_colorsByStatus[TasksProgress.TASK_PROGRESS_STATUS.late] = '#E44944';
		_colorsByStatus[TasksProgress.TASK_PROGRESS_STATUS.done] = '#53B02E';
		_colorsByStatus[TasksProgress.TASK_PROGRESS_STATUS.missed] = '#000000';
	}

	function draw(data) {
		data = data || [];
		var canvas = document.createElement('canvas');
		var ctx = canvas.getContext('2d');
		ctx.canvas.width = 168;
		ctx.canvas.height = 18;
		ctx.fillStyle = '#FFFFFF';
		ctx.strokeStyle = '#000000';
		ctx.fillRect(1, 1, 166, 16);

		var length = data.length;
		var each = 165 / length - 1;
		var xpos = 2;
		ctx.strokeStyle = '';
		for (var i = 0; i < length; i++) {
			ctx.fillStyle = _colorsByStatus[data[i]] || DEFAULT_COLOR;
			ctx.fillRect(xpos, 2, each, 14);
			xpos += each + 1;
		}

		return ctx.canvas.toDataURL('image/jpeg', 1.0);
	}

	ctor();
});
